import { getWeightTitle } from '../../lib/weight';

/**
 * Количество порций в карточке рецепта.
 *
 * Человек готовит на два дня или на семью — граммовки состава
 * умножаются на выбранное число прямо на странице. Считаем
 * от точного веса, а не от округлённой подписи: иначе ошибка
 * округления умножается вместе с весом. Правило округления берём
 * из общего модуля — то же, что на сервере.
 *
 * КБЖУ остаётся на порцию: это характеристика еды, а не закупки,
 * и подпись под плашкой так и говорит.
 */
const MIN_PORTIONS = 1;
const MAX_PORTIONS = 10;

export function initPortions($) {
    const $cards = $('.portions');
    if (!$cards.length) return;

    $(document).on('click', '.js-portions-step', function () {
        const $plate = $(this).closest('.portions');
        const step = parseInt($(this).attr('data-step'), 10);
        const current = parseInt($plate.attr('data-portions'), 10) || MIN_PORTIONS;
        const next = Math.min(MAX_PORTIONS, Math.max(MIN_PORTIONS, current + step));
        if (next === current) return;

        $plate.attr('data-portions', next);
        $plate.find('.portions__value').text(next);
        // Состав лежит рядом с плашкой, в той же карточке.
        $plate.closest('.recipe-card').find('.recipe-line__value').each(function () {
            const exact = parseFloat($(this).attr('data-weight'));
            if (!exact && exact !== 0) return;
            $(this).text(getWeightTitle(exact * next));
        });
    });
}
